import { api } from "@/lib/api";

export function visitorId() {
  try {
    let id = localStorage.getItem("rr_vid");
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("rr_vid", id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export async function track(type, meta) {
  try {
    await api.post("/events/track", { type, visitor_id: visitorId(), meta });
  } catch {
    /* analytics is best-effort; never block the UI */
  }
}

export function captureReferral() {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("rr_ref", ref);
  } catch {
    /* ignore */
  }
}

export function getReferral() {
  try {
    return localStorage.getItem("rr_ref") || undefined;
  } catch {
    return undefined;
  }
}
